import React from 'react';
import '../../css/FAQ.css';

function FAQ() {
    return (
        <div className="faq">
            <h1>Frequently Asked Questions</h1>

            <div className="faq-item">
                <h2>🔐 Is my order really confidential?</h2>
                <p>Absolutely. We use discreet packaging with no branding, and your details are never shared. Even the delivery agent won't know what's inside.</p>
            </div>

            <div className="faq-item">
                <h2>🚚 How long does delivery take?</h2>
                <p>We offer fast and secure delivery islandwide. Orders are typically delivered within 1-3 business days depending on your location in Sri Lanka.</p>
            </div>

            <div className="faq-item">
                <h2>💳 What payment methods do you accept?</h2>
                <p>We accept a variety of secure payment options including credit/debit cards, bank transfers, and cash on delivery (COD) for selected areas.</p>
            </div>

            <div className="faq-item">
                <h2>🧾 Will the billing name show what I purchased?</h2>
                <p>No. Our billing is completely confidential and will not mention any product or adult-related information.</p>
            </div>

            <div className="faq-item">
                <h2>🧼 How do I clean and store the toys?</h2>
                <p>We recommend using a toy cleaner or mild antibacterial soap and warm water. Store your toys in a cool, dry place away from direct sunlight and ensure they are dry before storage.</p>
            </div>

            <div className="faq-item">
                <h2>📞 Can I contact someone for help?</h2>
                <p>Of course! Our customer support team is friendly and non-judgmental. You can contact us via email, WhatsApp, or live chat for any questions or concerns.</p>
            </div>
        </div>
    );
}

export default FAQ;
